import PortalRoleAndAssignmentsBoilerplate from "./boilerPlates/roleBoilerplates/PortalRoleAndAssignmentsBoilerplate"
import PortalRoleTempateWithPortalRoleLnksBoilerplate from "./boilerPlates/templateBoilerplates/PortalRoleTempateWithPortalRoleLnksBoilerplate"
import RMStateWebWorker from "./RATMStateWebWorker"
import WebWorker from "./RATMWebWorkerSetup"
import mutate from "./Mutate"
import stateBoilerplate from "./boilerPlates/stateBoilerplate"

const ratmService = {
    webWorker: new WebWorker(RMStateWebWorker),
    timeFormat: "MM/DD/YY",
    searchRolesAndAssignmentsKeys: ["RoleName", "Description"],
    searchRoleTemplatesKeys: ["Name", "Description"],
    rolesAndAssignmentsCopy: [PortalRoleAndAssignmentsBoilerplate],
    roleTemplatesCopy: [PortalRoleTempateWithPortalRoleLnksBoilerplate],
    state: stateBoilerplate,
    manageState: (keys: Array<{ key: string, value?: any }>) => {
        //@ts-ignore
        ratmService.webWorker.postMessage({ action: "updateRATMState", payload: mutate(ratmService.state, keys) })
    }
}

export default ratmService